"use strict";
/* import { Dispatch, SetStateAction } from 'react';

export type Theme = 'default' | 'video' | 'ux' | 'ugc-cab';

interface WithRotation {
    rotation?: boolean;
}

interface WithLabel {
    label: string;
}

export type AttachmentPosition = 'top' | 'bottom';

export type AttachmentType = 'image' | 'video';

interface AbstractAttachment {
    position: AttachmentPosition;
    type: AttachmentType;
}

export interface ImageAttachment extends AbstractAttachment {
    type: 'image';
    url: string;
}

export type VideoService = 'youtube' | 'efir' | 'vh' | 'resource';

export interface VideoAttachment extends AbstractAttachment {
    type: 'video';
    service: VideoService;
    id: string;
    extraParams?: string;
}

export type Attachment = ImageAttachment | VideoAttachment;

interface WithAttachment {
    attachment?: Attachment;
}

interface WithLogic {
    showIf?: any | null;
}

export const QuestionTypes = [
    'choice',
    'clickmapVideo',
    'email',
    'emotion',
    'geoText',
    'longText',
    'number',
    'rating',
    'scale',
    'shortText',
    'sidebyside',
    'ux'
] as const;

export type QuestionType = typeof QuestionTypes[number];

interface AbstractQuestion extends WithLabel, WithLogic, WithAttachment {
    id: number;
    type: QuestionType;
    required: boolean;
}

export interface SpecialOption extends WithLabel {
    enabled: boolean;
    checked?: boolean;
}

export type SpecialOptionKey =
    | 'noOpinionAnswer'
    | 'noAnswer'
    | 'otherAnswer'
    | 'otherAnswerWithText';

interface QuestionWithNoAnswer extends AbstractQuestion {
    noAnswer: SpecialOption;
}

interface QuestionWithNoOpinionAnswer extends AbstractQuestion {
    noOpinionAnswer: SpecialOption;
}

export interface QuestionImageOption extends WithLabel {
    id: number;
    url: string;
    checked?: boolean;
}

export interface QuestionImageDimensions {
    width: number;
    height: number;
}

export interface SideBySideQuestion extends QuestionWithNoOpinionAnswer, QuestionWithNoAnswer, WithRotation {
    type: 'sidebyside';
    dimensions?: QuestionImageDimensions | null;
    options: QuestionImageOption[];
}

// режимы просмотра: обычное видео / зажимание мыши для тестов креативов
export type VideoQuestionViewMode = 'view' | 'pointer-hold';

export interface VideoQuestion extends AbstractQuestion {
    type: 'clickmapVideo';
    attachment: VideoAttachment;
    after: {
        label: string;
    };
    mode?: VideoQuestionViewMode;
}

export enum AttachmentStatus {
    Initial,
    Playing,
    End
}*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTableQuestion = exports.QuestionTypes = exports.TimeLimitType = exports.AttachmentStatus = void 0;
exports.AttachmentStatus = {
    Initial: 0,
    Playing: 1,
    End: 2,
    0: 'Initial',
    1: 'Playing',
    2: 'End'
};
exports.TimeLimitType = {
    NOT_MORE: 0,
    NOT_LESS: 1,
    WAIT_VIDEO_END: 2,
    0: 'NOT_MORE',
    1: 'NOT_LESS',
    2: 'WAIT_VIDEO_END'
};
/*
export interface StatusProps {
    handleStatus: Dispatch<SetStateAction<AttachmentStatus>>
    status: AttachmentStatus
}
*/
exports.QuestionTypes = {
    CHOICE: 'choice',
    CLICKMAP_VIDEO: 'clickmapVideo',
    EMAIL: 'email',
    EMOTION: 'emotion',
    GEO_TEXT: 'geoText',
    LONG_TEXT: 'longText',
    NUMBER: 'number',
    RATING: 'rating',
    SCALE: 'scale',
    SHORT_TEXT: 'shortText',
    SIDE_BY_SIDE: 'sidebyside',
    UX: 'ux',
    TABLE: 'table',
    TABLE_SCALE: 'tableScale',
    DATE: 'date'
};
function isTableQuestion(q) {
    const qType = q.type;
    return qType === 'table' || qType === 'tableScale';
}
exports.isTableQuestion = isTableQuestion;
